// All money is integer USD cents until the moment it is displayed.

const usd0 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});
const usd2 = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function money(cents: number, decimals: 0 | 2 = 2): string {
  return (decimals === 0 ? usd0 : usd2).format(cents / 100);
}

// Compact form for big numbers: $1.2M, $15K, $500K
export function moneyCompact(cents: number): string {
  const dollars = cents / 100;
  if (dollars >= 1_000_000)
    return `$${(dollars / 1_000_000).toFixed(dollars % 1_000_000 === 0 ? 0 : 1)}M`;
  if (dollars >= 1_000)
    return `$${Math.round(dollars / 1_000)}K`;
  return usd0.format(dollars);
}

// Compact form that always keeps one decimal, for the sold-out stats:
// $2.6K, $35.4K, $97.0K, $1.2M. (moneyCompact rounds to whole K/M instead.)
export function moneyCompact1(cents: number): string {
  const dollars = cents / 100;
  if (dollars >= 1_000_000) return `$${(dollars / 1_000_000).toFixed(1)}M`;
  if (dollars >= 1_000) return `$${(dollars / 1_000).toFixed(1)}K`;
  return usd0.format(dollars);
}

export function savingsCents(wholesaleCents: number, costCents: number): number {
  return Math.max(0, wholesaleCents - costCents);
}

export function savingsPct(wholesaleCents: number, costCents: number): number {
  if (wholesaleCents <= 0) return 0;
  return Math.round(((wholesaleCents - costCents) / wholesaleCents) * 100);
}

// Total savings across a full quantity - the hero number in the pitch.
export function totalSavingsCents(
  wholesaleCents: number,
  costCents: number,
  qty: number,
): number {
  return savingsCents(wholesaleCents, costCents) * qty;
}
